import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import React, { useState } from 'react';
import {
  FDBox, FDStack, FDBodyText,
} from '@facet-wealth/design';
import { noop } from 'Helpers/PropTypes';
import PropTypes from 'prop-types';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import RichTextField from 'Components/ComponentLibrary/Molecules/RichTextField';
import { Box } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import moment from 'moment/moment';
import { dataAttrs } from 'Helpers/Testing';
import useDebounceWithCallback from 'Hooks/useDebounceWithCallback';

const useStyles = makeStyles(() => ({
  inputContainer: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
  },
}));


const InsightEditor = ({
  onSubmit,
}) => {
  const classes = useStyles();

  const {
    resource,
  } = useMetaLayoutContext();
  const [currentVal] = useState(resource.attr('content'));
  const [warningText, setWarningText] = useState('');
  const [saving, setSaving] = useState(false);

  /** Auto saves a draft message if the content of the draft message changes */
  const autoSaveInsight = useDebounceWithCallback(async (val) => {
    try {
      setSaving(true);
      resource.attr('content', val);
      await resource.submit();
      setWarningText('');
      await onSubmit();
    } catch (err) {
      if (err.errors && err.errors.length > 0) {
        setWarningText(err.errors[0].shortDetail);
      } else {
        setWarningText('Failed to update insight');
      }
    } finally {
      setSaving(false);
    }
  }, 1250, []);

  let statusMessage = 'Edits will be auto-saved as you type';
  const lastSaved = resource.attr('lastSaved');
  if (lastSaved) {
    statusMessage = `Last saved ${moment(lastSaved).calendar()}`;
  }
  if (saving) {
    statusMessage = 'Saving...';
  }

  return (
    <FDStack direction={'column'} spacing={3}>
      <Box
        className={classes.inputContainer}
        {...dataAttrs('scenario-insight-editor')}
      >
        <FDStack direction={'column'} width={'100%'}>
          <FDBox width={'100%'}>
            <RichTextField
              inputMinHeight={500}
              inputMaxHeight={600}
              onChange={(val) => {
                autoSaveInsight(val);
              }}
              value={currentVal}
              rounded
              placeholder={'Type here...'}
            />
          </FDBox>
          <FDBodyText size={'sm'} color={'textAttention'} value={warningText} />
        </FDStack>
      </Box>
      <FDStack direction={'column'}>
        <FDBodyText
          size={'sm'}
          color={resource.isTruthy('isOverCharacterLimit') ? 'textAttention' : 'textPrimary'}
          value={`${resource.attr('characterCount')}`}
        />
        <FDBodyText
          size={'sm'}
          color={'textPrimary'}
          value={statusMessage}
          {...dataAttrs('scenario-insight-status-message')}
        />
      </FDStack>
    </FDStack>
  );
};

InsightEditor.defaultProps = {
  onSubmit: noop,
};

InsightEditor.propTypes = {
  onSubmit: PropTypes.func,
};

export default InsightEditor;
